import { useState } from "react";
import { Link } from "react-router-dom";
import type { Product } from "@/mocks/products";
import SmartImage from "@/components/base/SmartImage";

export default function ProductCard({ product, index }: { product: Product; index?: number }) {
  const [activeColor, setActiveColor] = useState(product.colorways[0]?.name ?? "");
  const active = product.colorways.find((c) => c.name === activeColor) ?? product.colorways[0];
  const imgSrc = active?.img ?? product.img;

  return (
    <div className="group">
      <Link to={`/product/${product.slug}`} className="block cursor-pointer">
        <div className="relative aspect-square md:aspect-auto md:h-[360px] mb-4 md:mb-6 overflow-hidden bg-white">
          <div className="absolute inset-0 p-4 md:p-8 transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]">
            <div className="relative w-full h-full">
              <SmartImage
                src={imgSrc}
                alt={`${product.name} — ${active?.name ?? ""}`}
                tone="light"
                imgClassName="block w-full h-full object-contain object-center"
                imgStyle={{ transform: `scale(${product.scale ?? 1})` }}
              />
            </div>
          </div>
          {typeof index === "number" && (
            <span className="absolute top-0 left-0 text-[10px] tracking-[0.24em] uppercase text-neutral-400">
              {String(index + 1).padStart(2, "0")}
            </span>
          )}
        </div>
      </Link>
      <div className="flex items-start justify-between gap-1.5 md:gap-4">
        <div className="min-w-0 flex-1">
          <p className="text-[11px] md:text-[10px] tracking-[0.2em] uppercase text-neutral-500 mb-1.5">{product.category}</p>
          <Link
            to={`/product/${product.slug}`}
            className="text-[12px] md:text-[14px] leading-[1.3] text-neutral-900 hover:text-primary-600 transition mb-2 block cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis"
          >
            {product.name}
          </Link>
          <div className="flex items-center gap-1.5 mt-2">
            {product.colorways.map((c) => {
              const selected = c.name === activeColor;
              return (
                <button
                  key={c.name}
                  type="button"
                  title={c.name}
                  aria-label={c.name}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveColor(c.name);
                  }}
                  className={`w-3 h-3 rounded-full border transition cursor-pointer ${
                    selected ? "border-neutral-900 ring-1 ring-neutral-900/40" : "border-neutral-300 hover:border-neutral-500"
                  }`}
                  style={{ backgroundColor: c.hex }}
                />
              );
            })}
          </div>
        </div>
        <span className="text-[12px] md:text-[14px] text-neutral-900 whitespace-nowrap shrink-0 -ml-1 md:ml-0">${product.price}</span>
      </div>
    </div>
  );
}